import React from 'react'
import { Grid, Typography, Divider, Paper, Box } from '@mui/material'
import { Progress } from 'react-sweet-progress';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WarningIcon from '@mui/icons-material/Warning';
import DangerousIcon from '@mui/icons-material/Dangerous';
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
/** 
 * 
 * This component is expecting the following input. 

{
    "Order": "30",
    "Visible": "1",
    "Label": "Biometrics",
    "ComponentType": "STANDARD KEY VALUE ICON CARD",
    "ComponentValues":[
        {
            "Visible": "1",
            "Label": "Blood Pressure",
            "Value": "Normal",
            "ValueGrade": "1"
        },
        {
            "Visible": "1",
            "Label": "Total Cholesterol",
            "Value": "85",
            "ValueGrade": "2"
        },
        {
            "Visible": "1",
            "Label": "LDL Cholesterol",
            "Value": "100",
            "ValueGrade": "3"
        },
        {
            "Visible": "1",
            "Label": "HDL Cholesterol",
            "Value": "100",
            "ValueGrade": "1"
        },
        {
            "Visible": "1",
            "Label": "Blood Sugar",
            "Value": "Normal",
            "ValueGrade": "1"
        },
        {
            "Visible": "1",
            "Label": "BMI",
            "Value": "18.5",
            "ValueGrade": ""
        }
    ]
}
*/

const BiometricsComponent = (props) => {

    const data = [...props.component.ComponentValues].filter((x) => { return x.Visible === '1' })
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }
    const GetIcon = ({ valuegrade }) => {
        if (valuegrade == "1") return <HealthAndSafetyIcon sx={{ color: '#4eb748' }} />
        if (valuegrade == "2") return <WarningIcon sx={{ color: '#E7C61E' }} />
        else return <DangerousIcon sx={{ color: '#9A3218' }} />
    }
    const ProgressBar = ({ percent, status }) => {
        return (
            <Progress
                theme={{
                    success: {
                        symbol: ' ',// <HealthAndSafetyIcon sx={{ color: '#4eb748' }} />,
                        color: '#4eb748'
                    },
                    default: {
                        symbol: ' ', // <WarningIcon sx={{ color: '#E7C61E' }} />,
                        color: '#E7C61E'
                    },
                    error: {
                        symbol: ' ',//<DangerousIcon sx={{ color: '#9A3218' }} />,
                        color: '#E6323A'
                    },
                    active: {
                        symbol: ' ',//<DangerousIcon sx={{ color: '#9A3218' }} />,
                        color: '#AEAEAE'
                    }
                }}
                percent={percent}
                status={status}
            />
        )

    }

    const DisplayItem = ({ displayValues, index }) => {
        const progressValue = displayValues.ValueGrade === '1' ? 100 : displayValues.ValueGrade === '2' ? 60 : 20
        const progressStatus = displayValues.ValueGrade === '1' ? 'success' : displayValues.ValueGrade === '2' ? 'default' : 'error'
        return (
            <Box sx={{ borderBottom: 1, borderColor: "rgba(200,200,200,0.4)" }}>
                <Grid container direction="row" alignItems="center" >
                    <Grid item xs={5}>
                        <Typography variant="body2" align="left">{displayValues.Label}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="body2" align="left">{displayValues.Value}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <ProgressBar percent={progressValue} status={progressStatus} />
                    </Grid>
                </Grid>
            </Box>
        )
    }

    return (
        <Grid item lg={6} md={6} sm={4} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>

            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%'}}>
                <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }}>
                    <Grid container direction="row" alignItems="center" spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h5" align="center">{props.component.Label}</Typography>
                        </Grid>
                        <Grid item xs={12} m={1}>
                            <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                        </Grid>

                    </Grid>
                    {
                        data && data.map((displayValues, index) => {
                            return (
                                <DisplayItem displayValues={displayValues} key={"demographics" + index} index={index} />
                            )
                        })
                    }
                </Paper>
            </motion.div>
        </Grid>
    )
}

export default BiometricsComponent